import React from 'react';
import { Clock } from 'lucide-react';

const CutleryTableware = () => {
  const products = [
    {
      name: "Edible Spoons",
      description: "Our edible spoons are the environmentally friendly alternative to disposable plastic. Made from natural ingredients and certified according to ISO 22000, FSSAI, and FDA, they are ideal for ice cream, yogurt, or soups. Stable, delicious, and long-lasting—the perfect choice for events, catering, and conscious consumption.",
      image: require('../assets/images/spoon.jpg')
    },
    {
      name: "Edible Forks",
      description: "The edible fork combines stability, functionality, and enjoyment in a plastic-free, eco-friendly utensil. Whether for pasta, salads, or cakes, this crispy and durable fork enables a sustainable and delicious dining experience for takeaways, events, or everyday use.",
      image: require('../assets/images/fork.jpg')
    },
    {
      name: "Edible Coffee Stirrer",
      description: "The edible coffee stir sticks are the innovative, sustainable alternative to conventional wood stir sticks. Ideal for coffee specialties, and in the XL version perfect for tall latte macchiato glasses.",
      image: require('../assets/images/stirrer.jpg')
    },
    {
      name: "Edible Ice Cream Spoon",
      description: "These mini spoons combine innovation, enjoyment, and sustainability in a small, practical dessert spoon. Whether vanilla or chocolate, for soft serve, yogurt, sorbet, or harder ice cream, it fits perfectly in the hand and ensures an unforgettable taste experience. Made from natural ingredients, plastic-free, and with a long lifespan.",
      image: require('../assets/images/icecream.jpg')
    },
    {
      name: "French Fries Fork",
      description: "The fork combines unique ketchup flavor, practical use, and sustainability in an edible chip fork. Perfect for fries, currywurst, or finger food, plastic-free, crispy, and eco-friendly.",
      image: require('../assets/images/fries.jpg')
    }
  ];

  return (
    <div className="cutlery-page">
      {/* Hero Section */}
      <section className="products-hero">
        <div className="container">
          <h1 className="display-medium">Cutlery & Tableware</h1>
          <p className="body-large">
            Sustainable, edible cutlery and tableware solutions for a greener future. 
            Perfect for events, food service, and eco-conscious businesses.
          </p>
        </div>
      </section>

      {/* Coming Soon Banner */}
      <section className="coming-soon-section">
        <div className="container">
          <div className="coming-soon-banner">
            <Clock className="w-12 h-12 text-brand-green" />
            <h2 className="heading-2">Coming Soon</h2>
            <p className="body-large">
              We're expanding our product range! Our full line of edible cutlery and tableware 
              will be available soon. Contact us to learn more or to be notified when these products launch.
            </p>
          </div>
        </div>
      </section>

      {/* Preview Products Section */}
      <section className="packaging-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Upcoming Products</h2>
            <p className="body-large">
              A preview of our sustainable cutlery and tableware collection.
            </p>
          </div>

          <div className="products-grid cutlery-products-grid">
            {products.map((product, index) => (
              <div key={index} className="product-card cutlery-product-card">
                <div className="cutlery-product-image">
                  <img src={product.image} alt={product.name} />
                </div>
                <h3 className="heading-3">{product.name}</h3>
                <p className="body-medium">{product.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-2">Interested in Our Cutlery Range?</h2>
            <p className="body-large">
              Get in touch to learn more about our upcoming products or to place a pre-order.
            </p>
            <a href="/contact" className="btn btn-primary">
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CutleryTableware;
